import {Component, Input, OnInit} from '@angular/core';
import {SkillGroupProblemModel} from '../../../../models/student/skill.model';
import {SchoolGroupsService} from '../../../../services/school/school-groups.service';
import {ActivatedRoute, Params} from '@angular/router';
import {SkillGroupStrugglingStudentsModel} from '../../../../models/edu-admin/SkillGroupStrugglingStudents.model';

@Component({
  selector: 'app-group-dash-problem-areas',
  templateUrl: './group-dash-problem-areas.component.html',
  styleUrls: ['./group-dash-problem-areas.component.css']
})
export class GroupDashProblemAreasComponent implements OnInit {

  groupId: string;

  currentProblemArea: SkillGroupStrugglingStudentsModel = null;
  problemAreas: SkillGroupStrugglingStudentsModel[] = [];
  isFetchingData = false;

  studentProblemSkills: SkillGroupProblemModel[] = [];

  selectProblemAreas = false;

  constructor(private route: ActivatedRoute,
              private groupSv: SchoolGroupsService) { }

  ngOnInit() {

    this.route.parent.params.subscribe((params: Params) => {

      this.groupId = params.groupId;

      this.groupSv.fetchProblemSkillGroups(this.groupId).subscribe((skillGroups) => {

        this.isFetchingData = false;
        this.problemAreas = skillGroups;
        if (this.problemAreas.length > 0) {
          this.currentProblemArea = this.problemAreas[0];
          this.fetchStudentProblemSkills();
        }

      });

    });

  }

  fetchStudentProblemSkills() {

    this.groupSv.fetchStudentsForProblemSkillGroup(this.groupId, this.currentProblemArea._id).subscribe((studentProblemAreas) => {

      this.studentProblemSkills = studentProblemAreas;

    });

  }

  onSelectProblemAreaClicked() {
    this.selectProblemAreas = true;
  }

  onProblemAreaClicked(problemArea: SkillGroupStrugglingStudentsModel) {

    this.selectProblemAreas = false;

    this.currentProblemArea = problemArea;
    this.studentProblemSkills = [];

    this.fetchStudentProblemSkills();

  }

}
